import { useNavigate } from "react-router-dom";
import { ShieldOff, Home, ArrowLeft } from "lucide-react";
import { AuthLayout } from "@/components/ui/auth-layout";
import { Panel } from "@/components/ui/panel";
import { Heading } from "@/components/ui/heading";
import { Text, Muted } from "@/components/ui/text";
import { Button } from "@/components/ui/button";

export default function ForbiddenRoute() {
  const navigate = useNavigate();

  return (
    <AuthLayout>
      <Panel padding="lg" className="space-y-6">
        {/* Icon */}
        <div className="flex justify-center">
          <div className="rounded-full bg-orange-100 p-3">
            <ShieldOff className="h-10 w-10 text-orange-600" />
          </div>
        </div>

        {/* Content */}
        <div className="text-center space-y-2">
          <Heading size="lg">403 - Forbidden</Heading>
          <Muted>You don&apos;t have permission to access this resource.</Muted>
        </div>

        <Text className="text-center">
          This area is restricted. If you believe you should have access, please contact your
          workspace administrator.
        </Text>

        {/* Actions */}
        <div className="flex flex-col gap-2">
          <Button variant="primary" className="w-full" onClick={() => navigate("/")}>
            <Home className="mr-2 h-4 w-4" />
            Go to Home
          </Button>
          <Button variant="outline" className="w-full" onClick={() => navigate(-1)}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Go Back
          </Button>
        </div>
      </Panel>
    </AuthLayout>
  );
}
